<div
  class="finra-html-grid-cell-container"
  [innerHTML]="htmlContent">
</div>
